import localScaleManager from "../../../helpers/LocalScaleManager";
import { ActionButton } from "./actionButton";
import { WebSocketManager } from "../../../helpers/webSocketManager";
// import { tweenConfigs } from "../../../helpers/tweensConfigs";

export class ChangeableTextButton extends ActionButton {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param texture {string}
   * @param serverEventAddress {string}
   * @param isReserveBtn {Boolean}
   * @param gameObj {Phaser.GameObjects.Image}
   */
  constructor(
    scene,
    table,
    texture,
    serverEventAddress,
    isReserveBtn,
    gameObj
  ) {
    super(scene, table, texture, serverEventAddress, isReserveBtn, gameObj);
    this.callValue = 0;
    this.isReserveBtn = isReserveBtn;
    this.text = this.scene.add
      .bitmapText(0, 0, "HelveticaNeueTeal", `Call`)
      .setVisible(false);
    this.table.poolArray.push(this.text);

    this.text.setData("width", this.text.width);
    this.text.setData("height", this.text.height);
    this.textInitY = 0;
    this.checkBoxWidth = 0;
    this.availableWidth = 0;
  }
  updateText(callValue) {
    // FIXME: This is responsive for only 6 digits.
    this.callValue = callValue;
    let callValueDemo = "";
    if (this.callValue >= 1000000) {
      callValueDemo =
        (this.callValue / 1000000).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0] +
        "M";
    } else if (this.callValue) {
      callValueDemo = this.callValue.toLocaleString();
    }
    this.text.setText(`Call ${callValueDemo}`);
    if (!this.isReserveBtn) {
      this.text.setPosition(
        this.gameObj.x - this.text.width / 2,
        this.gameObj.y - this.text.height / 2
      );
    } else {
      if (this.text.width >= this.availableWidth) {
        this.text.setPosition(
          this.gameObj.x + this.checkBoxWidth - this.gameObj.displayWidth / 2,
          this.gameObj.y - this.text.height / 2
        );
      } else
        this.text.setPosition(
          this.gameObj.x - (this.text.width - this.checkBoxWidth) / 2,
          this.gameObj.y - this.text.height / 2
        );
    }
  }
  show(reserveStatus) {
    this.shown = true;
    if (this.gameObj.frame.name !== this.mainTexture)
      this.gameObj.setFrame(this.mainTexture, false, false);
    Phaser.Actions.SetVisible([this.gameObj, this.text], true);
    if (this.isReserveBtn) {
      this.activeReserveBtn(reserveStatus);
    }
    // if (this.scene.tweenEnable) {
    //   this.scene.tweens.add({
    //     targets: this,
    //     duration: tweenConfigs.actionButtons.show.duration,
    //     ease: tweenConfigs.actionButtons.show.ease,
    //     y: this.btnInitY,
    //     onComplete: () => {
    //       this.y = this.btnInitY;
    //     },
    //   });
    //   this.scene.tweens.add({
    //     targets: this.text,
    //     duration: tweenConfigs.actionButtons.show.duration,
    //     ease: tweenConfigs.actionButtons.show.ease,
    //     y: this.textInitY,
    //     onComplete: () => {
    //       this.text.y = this.textInitY;
    //     },
    //   });
    // } else {
    //   this.text.y = this.textInitY;
    //   this.y = this.btnInitY;
    // }
    this.enableInteractive();
  }
  hide() {
    if (this.isReserveBtn) {
      this.activeReserveBtn(false);
    }
    if (this.text.visible) this.text.setVisible(false);
    this.shown = false;
    // if (this.scene.tweenEnable) {
    //   this.scene.tweens.add({
    //     targets: [this, this.text],
    //     duration: tweenConfigs.actionButtons.hide.duration,
    //     ease: tweenConfigs.actionButtons.hide.ease,
    //     y: this.scene.gameHeight + this.displayHeight,
    //     onComplete: () => {
    //       Phaser.Actions.SetY(
    //         [this, this.text],
    //         this.scene.gameHeight + this.displayHeight
    //       );
    //       // Phaser.Actions.SetVisible([this, this.text], false);
    //     },
    //   });
    // } else {
    // Phaser.Actions.SetVisible([this.gameObj, this.text], false);
    //   Phaser.Actions.SetY(
    //     [this, this.text],
    //     this.scene.gameHeight + this.displayHeight
    //   );
    // }
  }
  async onClick() {
    if (
      this.scene.isSceneObjectsInteractive &&
      this.btnClicked &&
      this.isReserveBtn
    ) {
      let eventAddress = "";
      this.disableInteractive();
      await super.onClickTween();
      this.btnClicked = false;
      const data = {
        tableId: this.table.tableInfo.id,
        amount: this.callValue,
      };
      this.table.buttonManager.hideActionButtons();
      eventAddress =
        this.isReserveBtn && !this.reserveBtnClicked
          ? "poker.client-push.auto-action-none"
          : this.serverEventAddress;
      let timeout = setTimeout(() => {
        // this.enableInteractive();
        this.table.buttonManager.handleGameState(this.table.gameState);
      }, 3000);
      WebSocketManager.emitEvent(data, eventAddress)
        .then(() => {
          this.enableInteractive();
        })
        .catch(() => {
          this.table.buttonManager.handleGameState(this.table.gameState);
        })
        .finally(() => {
          // this.enableInteractive();
          clearTimeout(timeout);
          timeout = null;
        });
    } else {
      super.onClick();
    }
  }
  /***
   * changeable Text Button Position Controls
   * @param width {number} table.displayWidth
   * @param height {number} table.displayHeight
   */
  positionControls(width, height) {
    // super.positionControls(width, height, btnPosition);

    this.textSize = this.gameObj.displayWidth / 2.5;
    localScaleManager.scaleBitMapText(
      this.text,
      this.textSize,
      this.gameObj.displayHeight / 2.3,
      0,
      1,
      false
    );
    // this.text.setLetterSpacing(this.gameObj.displayWidth / 20);
    // this.text.setFontSize(this.gameObj.displayWidth/2.4);

    this.text.setPosition(
      this.gameObj.x - this.text.width / 2,
      this.gameObj.y - this.text.height / 2
    );
    // this.btnInitY = this.y;
    // this.textInitY = this.text.y;
    this.checkBoxWidth = this.gameObj.displayWidth * 0.25;
    this.availableWidth = this.gameObj.displayWidth - this.checkBoxWidth;
    this.updateText("");
  }
  /***
   * changeable Text Button Position Controls
   * @param width {number} table.displayWidth
   * @param height {number} table.displayHeight
   */
  reposition(width, height) {
    // super.reposition(width, height, btnPosition);
    this.text.setPosition(
      this.gameObj.x - this.text.width / 2,
      this.gameObj.y - this.text.height / 2
    );
    // this.btnInitY = this.y;
    // this.textInitY = this.text.y;
    this.availableWidth = this.gameObj.displayWidth - this.checkBoxWidth;
  }
  remove() {
    super.remove();
    this.text.destroy();
  }
}
